import React, {useContext, useCallback} from 'react'
import * as PropTypes from 'prop-types'
import {KEY_JANUS, useTranslation} from '@modifi/plugin-i18n'
import {FormActionsContext} from '@modifi/plugin-forms'
import {ButtonPrimary, ButtonSecondary} from '@modifi/ui'

import {StyledSubmitButton} from './styles'

const ConnectedSubmitButton = ({isCaptchaValid, hasError, colorSchema, ctaText, isSubmitting}) => {
  const {t} = useTranslation(KEY_JANUS)
  const {submit, canSubmit} = useContext(FormActionsContext)

  const handleSubmitClick = useCallback(
    e => {
      e && e.preventDefault()
      submit()
    },
    [submit]
  )

  return (
    <StyledSubmitButton
      onClick={handleSubmitClick}
      buttonComponent={colorSchema === 'secondary' ? ButtonSecondary : ButtonPrimary}
      block
      active={canSubmit && !isSubmitting && isCaptchaValid}
      data-target="submit-form"
    >
      {t(hasError ? 'signup.cta.try-again' : ctaText)}
    </StyledSubmitButton>
  )
}

ConnectedSubmitButton.propTypes = {
  isCaptchaValid: PropTypes.bool.isRequired,
  hasError: PropTypes.bool,
  colorSchema: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  isSubmitting: PropTypes.bool,
  ctaText: PropTypes.string.isRequired,
}

ConnectedSubmitButton.defaultProps = {
  isSubmitting: false,
  hasError: false,
}

export default ConnectedSubmitButton
